export default __webpack_public_path__ + "static/info-a873c678b3924afdc7ebdf34afeac8a6.jpg";